import { connect } from 'react-redux'
import { SelectStandardOrPremiumNumberStepComponent } from './SelectStandardOrPremiumNumberStep'

const stateToProps = () => ({})

const dispatchToProps = {}

export const SelectStandardOrPremiumNumberStep = connect(
  stateToProps,
  dispatchToProps
)(SelectStandardOrPremiumNumberStepComponent)



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/SelectStandardOrPremiumNumberStep/SelectStandardOrPremiumNumberStep.container.ts